import '@patsnap-ui/icon/assets/solid/warning.svg'
import { ALL_DEV_STATUS_MAP } from '@patsnap/synapse_common_config'
import { getDicItemName } from '@patsnap/synapse_common_utils'
import { useLocale } from '@pharmsnap/shared/composition'
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api'
import { GIcon } from '../../ui/GIcon/GIcon'
import { GTooltip } from '../../ui/GTooltip/GTooltip'

export const BInactiveDevStatusTooltip = defineComponent({
  name: 'BInactiveDevStatusTooltip',
  props: {
    inactiveDevStatusIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    iconSize: {
      type: Number,
      default: 20,
    },
    iconClass: {
      type: String,
      default: 'text-gray-55',
    },
    label: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { inactiveDevStatusIds } = toRefs(props)
    const { localeUpcase } = useLocale()
    const inactiveDevStatusNames = computed(() =>
      inactiveDevStatusIds.value.reduce<string[]>((names, id) => {
        const devStatus = ALL_DEV_STATUS_MAP[id]
        if (devStatus) {
          names.push(getDicItemName(devStatus, localeUpcase.value))
        }
        return names
      }, [])
    )

    return {
      inactiveDevStatusNames,
    }
  },
  render() {
    const content = this.inactiveDevStatusNames.join(', ') || this.$tc('common.inactiveStatusTips')
    const label = this.label || (this.showLabel ? this.$tc('common.inactiveStatus') : '')
    return (
      <GTooltip
        theme="light"
        mode={label ? 'text' : 'icon'}
        iconName="SolidWarning"
        iconSize={this.iconSize}
        iconClass={this.iconClass}
        content={content}
      >
        {label ? (
          <div class="flex items-center">
            <GIcon class={['cursor-pointer', this.iconClass]} size={this.iconSize} svgName="SolidWarning"></GIcon>
            <span class="cursor-pointer ml-1 text-xs">{label}</span>
          </div>
        ) : null}
      </GTooltip>
    )
  },
})
